import { Box, Text, TextButton } from '@zillow/constellation-10';

const NothingToTransfer = ({ onFindListingsClick }: { onFindListingsClick: () => void }) => (
  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBlock: '400' }}>
    <Box css={{ display: 'flex', justifyContent: 'center', marginInline: { lg: '1200' }, textAlign: 'center' }}>
      <Text>
        All listings for these contact methods have been already transferred. To transfer more listings, search by other
        contact methods.
      </Text>
    </Box>
    <TextButton onClick={onFindListingsClick}>Find listings</TextButton>
  </Box>
);

export default NothingToTransfer;
